import React, { useRef, useState } from "react";
import ApplicationStore from "../../../../utils/localStorageUtil";
import PricingTabBR from "./PricingTabBR";

const PricingPage = () => {
  // ---------------------------------------------------------
  // DEFAULT INDEXES
  // ---------------------------------------------------------
  const [packages, setPackages] = useState(0);
  const [packagesTypes, setPackagesType] = useState(0);
  const [productIndex, setProductIndex] = useState(0);

  // ---------------------------------------------------------
  // SELECTED PRODUCT DATA
  // ---------------------------------------------------------
  const [productName, setProductName] = useState("");
  const [productCost, setProductCost] = useState(0);
  const [originalCost, setOriginalCost] = useState(0);

  const [giftCardCredit, setGiftCardCredit] = useState(0);

  const [productMonth, setProductMonth] = useState("");
  const [productKm, setProductKm] = useState("");

  const [deductibleType, setDeductibleType] = useState("");
  const [deductible, setDeductible] = useState("");
  
  const user_type = ApplicationStore().getStorage("user_type");

  // Stores selected complete product object
  const productRef = useRef(null);

  // ---------------------------------------------------------
  // PRODUCT CONTINUE
  // ---------------------------------------------------------
  const handleNext = () => {
    console.log("Selected Product:", productRef.current);

    console.log("Product Name:", productName);
    console.log("Product Cost:", productCost);
    console.log("Original Cost:", originalCost);
    console.log("Gift Card Credit:", giftCardCredit);
    console.log("Product Month:", productMonth);
    console.log("Product KM:", productKm);
    console.log("Deductible Type:", deductibleType);
    console.log("Deductible:", deductible);

    // Add your required action here.
    // Example:
    // navigate("/build-warranty");
  };

  return (
    <div>

      <PricingTabBR
        packages={packages}
        setPackages={setPackages}
        packagesTypes={packagesTypes}
        setPackagesType={setPackagesType}
        productIndex={productIndex}
        setProductIndex={setProductIndex}
        setProductName={setProductName}
        setProductCost={setProductCost}
        handleNext={handleNext}
        setPackagesText={() => { }}
        setGiftCardCredit={setGiftCardCredit}
        setOriginalCost={setOriginalCost}
        productRef={productRef}
        setProductMonth={setProductMonth}
        setProductKm={setProductKm}
        setDeductibleType={setDeductibleType}
        setDeductible={setDeductible}
      />
    </div>
  );
};

export default PricingPage;